import axios from '@/config/api.request'

export default {
    // 查询货币价格历史图表
    getPriceHistories(currency) {
        return axios.request({
            url: '/iobots/history/price',
            method: 'get',
            params: { currency }
        })
    }
}